module.exports = __webpack_public_path__ + "img/pride-display.47d45c91.png";